import React from 'react'
import { Grid, Typography } from '@mui/material'
import { IconQuestionCircle } from '@tabler/icons'
import { Button } from 'torqcloud-ui'
import { appConfig } from '@/config'
import { userGuide } from '@/constants/routing'

type PageTypeProps = {
  title: string
  subtitle?: string | null
  actionComponent?: (() => React.ReactNode) | null
  helpText?: string
}

const defaultProps = {
  helpText: 'Get Help',
}

const PageTitle = ({ title, subtitle, actionComponent, helpText }: PageTypeProps) => {
  const onGetHelp = () => {
    try {
      window.open(userGuide(), '_blank')
    } catch (error) {
      console.error('Error opening FAQ:', error)
    }
  }

  return (
    <Grid container justifyContent="space-between" spacing={1} sx={{ mb: 3 }}>
      <Grid item xs>
        <Typography color="textPrimary" variant="h3">
          {title}
        </Typography>
        {subtitle && (
          <Typography color={theme => theme.typography.textColor.secondary} variant="subtitle2" sx={{ marginTop: '0.8rem' }}>
            {subtitle}
          </Typography>
        )}
      </Grid>
      <Grid item xs="auto" sx={{ display: 'flex', gap: 2, flexDirection: 'column', justifyContent: 'center' }}>
        {actionComponent && actionComponent()}

        {appConfig.helpBaseUrl && (
          <Button variant="outlined" onClick={onGetHelp}>
            <IconQuestionCircle style={{ paddingRight: '8px', height: 'auto' }} />
            {helpText ?? defaultProps.helpText}
          </Button>
        )}
      </Grid>
    </Grid>
  )
}

export default PageTitle
